import { _t } from "app/i18n/i18n";
import { FaIcon } from "lib/FaIcon";
import { FilterPanel } from "pages/redesign/viewLayout/sidePanel/FilterPanel";
import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "./filter-bar.css";

export function MobileFilterButton({ aggregations, themeInFocusData }) {
  const [isShowModal, setShowModal] = useState(false);

  return (
    <>
      <Button onClick={() => setShowModal(true)} size="sm" variant=" text-dark text-nowrap mr-2 px-2 filter-button">
        <FaIcon icon="fas fa-sliders-h mr-1 fa-lg " align=" " />
        {_t("Filter")}
      </Button>
      <Modal show={isShowModal} scrollable={true}>
        <Modal.Header closeButton={true} onHide={() => setShowModal(false)}>
          <h3 className="font-weight-lighter">{_t("Add Report Filter:")}</h3>
        </Modal.Header>
        <Modal.Body>
          <FilterPanel aggregations={aggregations} themeInFocusData={themeInFocusData} />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowModal(false)}>{_t("Apply Filters")}</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
